/**
 * Erkennung einer Katalognummer (K1).
 *
 * Kundschaft nennt am Telefon "Nr. 120-042", "120-042" oder "die 42 aus
 * dem Herbstkatalog" — getippt wird davon "120-42". Diese Funktion sagt,
 * ob eine Eingabe eine Katalognummer ist, und bringt sie auf die
 * kanonische Form, unter der die Tabelle sie führt: dreistellig
 * aufgefüllter laufender Teil, ohne "Nr."-Vorsatz.
 *
 * Das Muster ist Vorgabe aus K1, erweitert in K1a, und ABSICHTLICH eng
 * — es ist dasselbe wie in api/lib/katalog.php, und die beiden müssen
 * zusammen geändert werden (der Server prüft jede Nummer noch einmal
 * selbst; hier entscheidet sich nur, ob das Feld eine Auflösung
 * versucht):
 *
 *   ^(Nr\.)?\s*(\d{3})-(\d{1,3})([a-z])?$
 *
 * Das Kleinbuchstaben-Suffix kommt aus dem Altbestand: "Nr.118-250b"
 * ist eine real vergebene Nummer (nachgeschobener Titel) und wird am
 * Telefon so genannt. Es bleibt an der kanonischen Form stehen
 * ("118-250b", nicht "118-250").
 *
 * Was NICHT durchgeht, mit Absicht:
 *   - B-2026-0208, Ü-2026-0001, G-1287 — beginnen mit einem Buchstaben.
 *   - Eine nackte ISBN (10/13 Zeichen) — trägt keinen Strich, auch
 *     "316148410x" mit kleinem x nicht.
 *   - Eine ISBN mit Strichen ("978-3-7725-2891-0") — mehr als zwei
 *     Gruppen, der Anker am Ende lässt sie nicht durch; das Suffix
 *     steht für EINEN Buchstaben nach der zweiten Gruppe, nicht für
 *     weitere Gruppen.
 *   - Shop-Nummern ("#1287", "1287") — kein Strich.
 *   - "118-250B" mit GROSSbuchstaben — vergeben ist das Suffix klein.
 */
export function katalogNummerErkennen(roh: string): string | null {
  const m = /^(Nr\.)?\s*(\d{3})-(\d{1,3})([a-z])?$/.exec(roh.trim());
  if (m === null) return null;
  return `${m[2]}-${m[3].padStart(3, '0')}${m[4] ?? ''}`;
}
